module.exports = __webpack_public_path__ + "static/media/platformerGame.46e246be.png";